import { render, staticRenderFns } from "./FormatReferenceTreeAddFormatTreeSelector.vue?vue&type=template&id=548e5598&scoped=true&"
import script from "./FormatReferenceTreeAddFormatTreeSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatReferenceTreeAddFormatTreeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatReferenceTreeAddFormatTreeSelector.vue?vue&type=style&index=0&id=548e5598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548e5598",
  null
  
)

export default component.exports